import { checkoutAttemptStatuses } from "@/react/types/PaywallCheckoutAttempt";
import type { CheckoutAttemptStatus } from "@/react/types/PaywallCheckoutAttempt";

export const isCheckoutAttemptCompleted = (status: CheckoutAttemptStatus) =>
  status === checkoutAttemptStatuses.completed;

export const isCheckoutAttemptDelayedConfirmation = (
  status: CheckoutAttemptStatus,
) => status === checkoutAttemptStatuses.delayed_confirmation;

const isCheckoutAttemptProcessing = (status: CheckoutAttemptStatus) =>
  status === checkoutAttemptStatuses.processing;

const isCheckoutAttemptWaitingForConfirmation = (
  status: CheckoutAttemptStatus,
) => status === checkoutAttemptStatuses.waiting_for_confirmation;

export const isCheckoutAttemptFailed = (status: CheckoutAttemptStatus) =>
  status === checkoutAttemptStatuses.failed;

export const isCheckoutAttemptProcessingOrWaitingForConfirmation = (
  status: CheckoutAttemptStatus,
) =>
  isCheckoutAttemptProcessing(status) ||
  isCheckoutAttemptWaitingForConfirmation(status);
